import type { RejectionSuccessPayload } from '@/components/modal/Profile/rejectProfile/types';
import type { RejectedProfileQuery } from '@/modules/companyNeed/views/details/rejected-profiles/types';

export interface OptimisticRejectionWorker {
	id: string;
	firstname: string;
	lastname: string;
	picture?: string;
}

// Helper pur (sans dépendance au store Pinia) : construit les entrées optimistes à insérer dans la liste
// des profils non retenus avant que le serveur ne retourne la liste à jour.
export const buildOptimisticRejectedProfiles = (
	workers: OptimisticRejectionWorker[],
	payload: RejectionSuccessPayload
): RejectedProfileQuery[] =>
	workers.map((worker) => ({
		id: worker.id,
		firstname: worker.firstname,
		lastname: worker.lastname,
		picture: worker.picture,
		registered: false,
		refusalDate: new Date(),
		reason: payload.reasonLabel,
		comment: payload.comment || undefined,
	}));
